import { Box, styled } from '@material-ui/core';
import { distances } from '@setvi/shared/styles';

export const Container = styled(Box)({
  width: '100%',
  flex: 1,
  display: 'flex',
  overflow: 'hidden',
  gap: distances.px.base
});

export const AccordionsContainer = styled(Box)({
  width: '70%',
  display: 'flex',
  flex: 1,
  overflow: 'hidden auto',
  flexDirection: 'column',
  gridGap: distances.px.base
});

export const AIOverviewContent = styled(Box)({
  width: '100%',
  height: '500px',
  display: 'flex',
  flexDirection: 'column'
});
